export default __webpack_public_path__ + "static/media/secure.04fd1c14.svg";